export { GroupedSearchResults } from './GroupedSearchResults.component';
